'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _makeStyles = require('./../makeStyles');

var _makeStyles2 = _interopRequireDefault(_makeStyles);

var _MenuItem = require('@material-ui/core/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var useStyles = (0, _makeStyles2.default)(function (theme) {
    return {
        root: {
            // Since menu list item is pulling from MUI, have to override to match recommended list
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.fontSize,
            fontWeight: theme.typography.fontWeight,
            lineHeight: _tokens.lineHeightParagraphMedium,
            textOverflow: 'ellipsis',
            '&.padding': {
                padding: _tokens.spacing40,
                display: 'block'
            },
            '&:hover': {
                color: '' + theme.palette.grey[600],
                backgroundColor: theme.palette.grey[250]
            },
            '&:focus': {
                color: '' + theme.palette.grey[600],
                backgroundColor: theme.palette.grey[250],
                boxShadow: '0 0 0 ' + _tokens.borderWidthThick + ' ' + theme.palette.focus + ' inset'
            },
            '&:active': {
                backgroundColor: theme.palette.grey[300],
                color: '' + theme.palette.grey[600]
            }
        }
    };
});

/**
 * An item in the dropdown version of the Button component?
 */
var DropdownButtonItem = _react2.default.forwardRef(function (props, ref) {
    var localClasses = useStyles();

    var className = props.className,
        classes = props.classes,
        disabled = props.disabled,
        _onClick = props.onClick,
        handleClose = props.handleClose,
        rest = _objectWithoutProperties(props, ['className', 'classes', 'disabled', 'onClick', 'handleClose']);

    var _React$useState = _react2.default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        isSelected = _React$useState2[0],
        setIsSelected = _React$useState2[1];

    return _react2.default.createElement(_MenuItem2.default, Object.assign({}, rest, {
        className: (0, _classnames2.default)(localClasses.root, className, 'padding'),
        disabled: disabled,
        onClick: function onClick(e) {
            setIsSelected(true);
            handleClose && handleClose(e);
            _onClick && _onClick(e);
        },
        classes: classes,
        ref: ref,
        role: 'option',
        'aria-selected': isSelected
    }));
});

DropdownButtonItem.muiName = 'DropdownButtonItem';
DropdownButtonItem.displayName = 'DropdownButtonItem';

DropdownButtonItem.propTypes = {
    /**
     * The content of the component.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * Class name to assign the component.
     */
    className: _propTypes2.default.string,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,
    /**
     * If `true`, the dropdown menu item will be disabled.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Callback triggered when dropdown menu item is clicked.
     */
    onClick: _propTypes2.default.func.isRequired
};

DropdownButtonItem.defaultProps = {
    disabled: false
};

exports.default = DropdownButtonItem;